// 组件对象，大写
import showAttachment from './showAttachment.vue'
export default showAttachment
